/**
 * FAQ API
 * FSD: entities/faq/api
 *
 * API 통신 로직
 * 백엔드 주소: /api/v1/faq
 */

import { publicClient } from "@/shared/api/public-client";
import type { FAQResponse, FAQListParams } from "../model";
/**
 * FAQ 목록 조회
 * GET /api/v1/faq
 */
export const fetchFAQList = async (
  params?: FAQListParams
): Promise<FAQResponse> => {
  try {
    const response = await publicClient.get("/v1/faq", {
      params: {
        page: params?.page || 1,
        pageSize: params?.pageSize || 10,
        category: params?.category,
      },
    });
    return response.data;
  } catch (error) {
    console.error("FAQ 목록 조회 실패:", error);
    throw error;
  }
};

/**
 * 특정 FAQ 조회
 * GET /api/v1/faq/{id}
 */
export const fetchFAQDetail = async (id: number): Promise<FAQResponse> => {
  try {
    const response = await publicClient.get(`/v1/faq/${id}`);
    return response.data;
  } catch (error) {
    console.error(`FAQ #${id} 조회 실패:`, error);
    throw error;
  }
};
